import * as React from "react";
import {cx} from "emotion";

import "./step-finalize.scss";

import {cs}          from "@Common/react/chain-services";
import {scopedState} from "@Common/react/scoped-state";
import {chain}       from "@Common/utils/fs";

import {ListNameSection} from "../list-name-section/list-name-section";
import {SectionGroup}    from "../section-group";

import {AssignNamesSection} from "./assign-names-section/assign-names-section";

export const StepFinalize = ({onBack, header, name, data, getDefaultListName, onComplete, xdQaName=undefined}) => cs(

    ["assignNamesSection", (_, next) => AssignNamesSection({
        data: scopedState(data, ["alternateName"]),
        xdQaName,
        next,
    })],
    ["listNameSection", (_, next) => ListNameSection({
        data: chain(
            scopedState(data, ["listName"]),
            (s) => ({
                ...s,
                value: s.value ?? getDefaultListName(),
            }),
        ),
        name,
        xdQaName,
        next,
    })],
    ["sections", ({assignNamesSection, listNameSection}, next) => SectionGroup({
        sections: [
            assignNamesSection,
            listNameSection,
        ],
        next,
    })],
    ({assignNamesSection, listNameSection, sections}) => (
        <div className="step-finalize-88l">

            {header}

            <div className="content">
                <div className="build-section">
                    <div className="title" xd-qa-type="label" xd-qa-name={xdQaName+" Build "+name+" List"}>
                        Build {name} List
                    </div>
                    <a className="edit" onClick={onBack} xd-qa-type="link" xd-qa-name={xdQaName+" Edit"}>
                        Edit
                    </a>
                </div>

                {assignNamesSection.render({showErrors: sections.showErrors})}

                {listNameSection.render({showErrors: sections.showErrors})}
            </div>

            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: onBack,
                    "xd-qa-type": "button",
                    "xd-qa-name": xdQaName+" Back",
                }}>
                    Back
                </button>

                <button {...{
                    className: cx("next", {disabled: sections.invalid}),
                    disabled: sections.submitDisabled,
                    onClick: () => sections.submit(onComplete),
                    "xd-qa-type": "button",
                    "xd-qa-name": xdQaName+" Create",
                }}>
                    Create List
                </button>
            </div>
        </div>
    )
);


